import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import { SvgIconProps } from '@mui/material/SvgIcon';
import React from 'react';

const RoleIcon = (props: SvgIconProps) => <AdminPanelSettingsIcon {...props} />;
export default RoleIcon;
